import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import Button from 'components/Button';

import './CashbackListItem.scss';

const b = block('cashback-list-item-desktop');

const ConditionPill = ({ text }) => <div className={b('condition-pill')}>{text}</div>;

const CashbackListItem = ({ item, onDelete }) => {
  const locale = useSelector(s => s.locale.locale);

  const formatDate = dateString => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' });
  };

  const formatAmount = amount => {
    if (!amount && amount !== 0) return '-';
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const getPlayerText = () => {
    if (item.isForAllPlayers) {
      return locale.allPlayers;
    }
    return item.targetPlayerUsername || locale.allPlayers;
  };

  const getProviderText = () => {
    return item.providerType === 'casino' ? locale.onTheSlots : locale.onSport;
  };

  const getStatusText = () => {
    switch (item.status) {
      case 'active':
        return locale.active;
      case 'completed':
        return locale.completed;
      case 'cancelled':
        return locale.cancelled;
      default:
        return item.status;
    }
  };

  return (
    <div className={b()}>
      <div className={b('cell')}>{getPlayerText()}</div>

      <div className={b('cell', { conditions: true })}>
        <div className={b('conditions-container')}>
          <ConditionPill text={item.isForAllPlayers ? locale.toAllPlayers : item.targetPlayerUsername} />
          <ConditionPill text={`${item.durationDays} ${locale.days}`} />
          <ConditionPill text={`${item.cashbackPercent}%`} />
          <ConditionPill text={getProviderText()} />
        </div>
      </div>

      <div className={b('cell')}>{formatAmount(item.totalAccruedAmount)}</div>

      <div className={b('cell')}>{formatDate(item.createdAt)}</div>

      <div className={b('cell')}>{getStatusText()}</div>

      {item.status === 'active' && (
        <div className={b('cell', { actions: true })}>
          <Button callBack={() => onDelete(item.id)} color="red">
            {locale.delete}
          </Button>
        </div>
      )}
    </div>
  );
};

export default CashbackListItem;
